module.exports = __webpack_public_path__ + "img/creation-de-logo.f19dad27.png";